import { render, staticRenderFns } from "./jiaocai.vue?vue&type=template&id=03874962&scoped=true&"
import script from "./jiaocai.vue?vue&type=script&lang=js&"
export * from "./jiaocai.vue?vue&type=script&lang=js&"
import style0 from "./jiaocai.vue?vue&type=style&index=0&id=03874962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03874962",
  null
  
)

export default component.exports